<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF BASIC
                    SCIENCES &
                    BIO-TECHNOLOGY</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">University Profile</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<!-- ABOUTUS
       ================================================== -->
<section class="aboutus-style-02">
    <div class="container">
        <div class="row align-items-center mt-n1-9">
            <div class="col-lg-6 col-xl-7 mt-1-9">
                <div class="col-lg-12 order-2 order-lg-1">
                    <img src="assets/img/ArniSchool04/1.jpg" class="cover-background w-100 h-100"/>
                </div>
            </div>
            <div class="col-lg-6 col-xl-5 mt-1-9">
                <div class="section-heading text-start mb-0">
                    <span class="sub-title">ABOUT US</span>
                </div>
                <h2 class="h1 mb-1-6 text-primary">The Arni School of Basic Sciences & Biotechnology</h2>
                <p>Welcome to The ARNI School of Basic Science & Biotechnology, the intersection of innovation and
                    inquiry. It offers a nourished ground for aspiring researchers, biotechnologists, and scientists.
                    The learning of the school is devoted to unraveling the mysterious world of science and the universe
                    through cutting-edge research and education in disciplines like physics, chemistry, mathematics, and
                    biotechnology. The school is designed to offer numerous BSC life science programs.
                </p>
            </div>
            <div class="col-lg-12 col-xl-12 mt-1-9">
                <p><b>Vision</b> – Our vision is to be a leading center of excellence in basic science and
                    biotechnology,
                    inspire innovations and discovery to create sustainable solutions for global challenges. We are
                    building a community of forward-thinking scientists and innovators to improve the quality of life.
                </p>
                <p><b>Mission </b> – Our mission is to empower upcoming scientists and researchers to address complex
                    challenges
                    and issues in the health, agriculture industries, and the environment with advanced technologies and
                    future-ready thought processes.
                </p>
                <h2>Undergraduate and Postgraduate Science Courses</h2>
                <p>ARNI offers academic programs that cater to students at graduate, post-graduate, and research levels,
                    providing high-quality education and cutting-edge interdisciplinary research. The department has
                    well-equipped laboratories for various sciences, including Physics, MATLAB, Microbiology, Molecular
                    Biology, Cell Culture, Virology, Bio-Chemistry, and Physical, Organic, and Inorganic chemistry,
                    promoting research culture.
                </p>
                <p>The School offers undergraduate, postgraduate or master of science courses, and research degree
                    programs in various disciplines including Mathematics, Chemistry, Physics, Statistics,
                    Biotechnology, and Computers. It focuses on quality service, teamwork, partnerships, and innovation
                    patenting, aiming to achieve a balance between pure basic, strategic basic, applied, and
                    experimental development research.
                </p>
                <p><b>Scope</b> - The School of Basic Sciences & Biotechnology holds immense promise in molding the
                    scientific minds of tomorrow. It offers a foundational understanding of fundamental scientific
                    principles encompassing physics, chemistry, and biology, laying the groundwork for advanced research
                    and innovation. Biotechnology, a burgeoning field at the intersection of biology and technology,
                    finds ample scope here.
                </p>
                <ul>
                    <li> Students explore genetic engineering, bioinformatics, and bioprocessing through
                        interdisciplinary techniques; these fields have the potential to transform environmental
                        sustainability, healthcare, and agriculture.
                    </li>
                    <li> The school cultivates the practical skills, ethical reasoning, and critical thinking necessary
                        to tackle global issues.
                    </li>
                    <li> Its reach goes beyond academics, enabling graduates to lead the way in a variety of enterprises
                        and research projects.
                    </li>
                </ul>
                <p><b>If you are passionate about science, innovations, and technologies and looking to kick-start your
                    career in this field. Our course will guide you to your dream career. Join us now to be a part of
                    this world of science and Technology.
                </b></p>
            </div>
        </div>
        <div class="shape20">
            <img src="assets/img/bg/bg-02.jpg" alt="...">
        </div>
        <div class="shape18">
            <img src="assets/img/bg/bg-01.jpg" alt="...">
        </div>
        <div class="shape21">
            <img src="assets/img/bg/bg-03.jpg" alt="...">
        </div>
    </div>
</section>


<!-- COUNTER
        ================================================== -->
<section class="pt-0 ">
    <div class="container ">
        <div class="row mt-n1-9 text-center">
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper text-center">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-01.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">11</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Course</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-02.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">20</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Faculty</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-03.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">4</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Department</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-04.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">20</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Events</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- PARTNER
    ================================================== -->
<section class="bg-very-light-gray py-8">
    <div class="container">
        <div class="client-carousel owl-carousel owl-theme">
            <div class="text-center">
                <img src="assets/img/partners/partner-01.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-02.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-03.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-04.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-05.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-06.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-07.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-08.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-09.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-10.jpg" alt="...">
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="col-md-12 col-lg-12 col-sm-12 ">
                    <div class="event-schedule-table table-responsive">
                        <table class="table">
                            <thead>
                            <tr>
                                <th class="time">Life Science</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td class="time">BSC Medical</td>
                            </tr>
                            <tr>
                                <td class="time">Msc(Botany)</td>
                            </tr>
                            <tr>
                                <td class="time">Msc(Zoology)</td>
                            </tr>
                            <tr>
                                <td class="time">BSC Microbiology</td>
                            </tr>
                            <tr>
                                <td class="time">BSC Zoology</td>
                            </tr>
                            <tr>
                                <td class="time">BSC Botany</td>
                            </tr>
                            <tr>
                                <td class="time">BSC Forensic Science</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="col-md-12 col-lg-12 col-sm-12">
                    <div class="event-schedule-table table-responsive">
                        <table class="table">
                            <thead>
                            <tr>
                                <th class="time">Physics</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td class="time">BSC (Non-Medical)</td>
                            </tr>
                            <tr>
                                <td class="time">Msc(Physics)</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-md-12 col-lg-12 col-sm-12 ">
                    <div class="event-schedule-table table-responsive">
                        <table class="table">
                            <thead>
                            <tr>
                                <th class="time">Chemistry</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td class="time">Msc(Chemistry)</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-md-12 col-lg-12 col-sm-12 ">
                    <div class="event-schedule-table table-responsive">
                        <table class="table">
                            <thead>
                            <tr>
                                <th class="time">Maths</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td class="time">Msc (Math)</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
